const certificate = {
  // HeroSection
  'certificate.hero.homeLink': 'Home',
  'certificate.hero.currentPage': 'Completion Certificate & Certification',
  'certificate.hero.imgAlt': 'A still life of the certification lapel pin and completion certificate',

  // breadcrumb
  'certificate.breadcrumb.home': 'Home',
  'certificate.breadcrumb.pricing': 'Tuition & Benefits',
  'certificate.breadcrumb.current': 'Completion Certificate & Certification',

  // CertificationLevels
  'certificate.levels.label': 'CERTIFICATION LEVELS',
  'certificate.levels.title': 'Three Certification Tiers',
  'certificate.levels.titleEn': 'Three Certification Tiers',
  'certificate.levels.lead': 'Upon passing the practical examination at the end of each course, graduates receive an officially recognised certification from the Japan Butler Association. Certifications are awarded across three tiers, progressing in depth of expertise.',
  'certificate.levels.certNote': '* This is a private credential issued exclusively by the Japan Butler Association.',
  'certificate.levels.courseLabel': 'Awarded through: ',
  'certificate.levels.skillsTitle': 'Certified Skill Areas',
  'certificate.levels.courseLink': 'View course details',

  // Requirements
  'certificate.requirements.label': 'REQUIREMENTS',

  // ExamOverview
  'certificate.exam.label': 'PRACTICAL EXAM',

  // AwardItems
  'certificate.award.label': 'WHAT YOU RECEIVE',

  // UsageSection
  'certificate.usage.label': 'HOW TO USE',

  // FAQSection
  'certificate.faq.label': 'FAQ',
  'certificate.faq.title': 'Frequently Asked Questions',
  'certificate.faq.titleEn': 'Frequently Asked Questions',
  'certificate.faq.contactNote': 'For further enquiries, please use our',
  'certificate.faq.contactLink': 'contact form',
  'certificate.faq.contactSuffix': '.',

  // CTASection
  'certificate.cta.label': 'NEXT STEP',
  'certificate.cta.title': 'Start with Choosing Your Course',
  'certificate.cta.lead': 'The first step toward earning your certification is finding the right course. Explore your options through our free brochure or an individual consultation.',
  'certificate.cta.onlineNote': '* Online consultations are also available.',
  'certificate.cta.coursesBtn': 'Browse Courses',
  'certificate.cta.brochureBtn': 'Request a Brochure (Free)',
  'certificate.cta.consultBtn': 'Book a Consultation',

  // RelatedPages
  'certificate.related.label': 'LEARN MORE',
  'certificate.related.title': 'Related Pages',
  'certificate.related.titleEn': 'Explore Further',
  'certificate.related.arrowLabel': 'Learn more',

  // footer
  'certificate.footer.lastUpdated': 'Last updated: 13 June 2026',
  'certificate.backToTop.ariaLabel': 'Back to top',

  // certificateHero
  'certificate.hero.title': 'Completion Certificate & Certification',
  'certificate.hero.lead': 'Passing the practical examination at the end of each course earns you an officially recognised certification from the Japan Butler Association.',

  // certificationLevels data
  'certificate.level.0.name': 'Certified Associate Butler',
  'certificate.level.0.course': 'Essential Course',
  'certificate.level.0.lead': 'An entry-level certification demonstrating that the holder has acquired the foundational knowledge and skills of a professional butler. It attests proficiency in table manners, basic service etiquette, and introductory clothing care.',
  'certificate.level.0.skill.0': 'Table manners (foundation)',
  'certificate.level.0.skill.1': 'Basic service etiquette',
  'certificate.level.0.skill.2': 'Introductory clothing care',
  'certificate.level.0.skill.3': 'Communication fundamentals',
  'certificate.level.1.name': 'Certified Professional Butler',
  'certificate.level.1.course': 'Advanced Course',
  'certificate.level.1.lead': 'An intermediate certification demonstrating advanced service skills and hospitality management capability — from wine service to event coordination.',
  'certificate.level.1.skill.0': 'Wine and tea service',
  'certificate.level.1.skill.1': 'Event set-up and coordination',
  'certificate.level.1.skill.2': 'Advanced table coordination',
  'certificate.level.1.skill.3': 'Guest reception protocol',
  'certificate.level.2.name': 'Certified Master Butler',
  'certificate.level.2.course': 'Master Course',
  'certificate.level.2.lead': 'The highest-level certification, demonstrating comprehensive professional expertise and management capability — from household management to staff leadership and consultation.',
  'certificate.level.2.skill.0': 'Household management',
  'certificate.level.2.skill.1': 'Staff leadership and coaching',
  'certificate.level.2.skill.2': 'Consultation techniques',
  'certificate.level.2.skill.3': 'Comprehensive butler practice',

  // requirements
  'certificate.req.title': 'Certification Requirements',
  'certificate.req.lead': 'To earn a certification, you must meet the attendance requirement and pass both the written and practical examinations. Results are assessed against clear, objective standards.',
  'certificate.req.item.0.label': 'Attendance: 80% or above',
  'certificate.req.item.0.desc': 'A minimum attendance of 80% of all scheduled class days is required. If you miss a class for unavoidable reasons, make-up sessions or deferral to the next cohort (subject to a fee) may be arranged.',
  'certificate.req.item.1.label': 'Pass the written examination',
  'certificate.req.item.1.desc': 'A written examination covering the course content is held at the end of each course. Questions are drawn from the textbooks and lectures; the pass mark is 70/100.',
  'certificate.req.item.2.label': 'Pass the final practical examination',
  'certificate.req.item.2.desc': 'A practical examination simulating real butler duties. Movement, procedure, and responsiveness are assessed by multiple examiners against defined standards.',
  'certificate.req.retakeNote': 'If you do not pass the practical examination, you may resit on one occasion free of charge at the next scheduled session. Subsequent resit attempts are subject to a fee of JPY 11,000 (tax incl.).',

  // examOverview
  'certificate.exam.title': 'Final Practical Examination Overview',
  'certificate.exam.lead': 'The practical examination is an opportunity to demonstrate the skills you have acquired in a real-world setting. Content is calibrated to each course and increases in complexity at each level.',
  'certificate.exam.0.course': 'Essential Course',
  'certificate.exam.0.content': 'Table-setting and tea service demonstration',
  'certificate.exam.0.desc': 'Candidates are asked to demonstrate the correct table-setting procedure and the full sequence of a tea service. Accuracy of movement and elegance of manner are assessed.',
  'certificate.exam.1.course': 'Advanced Course',
  'certificate.exam.1.content': 'Formal dinner and wine service',
  'certificate.exam.1.desc': 'Candidates demonstrate the complete sequence from formal dinner table-setting through wine temperature management, uncorking, and pouring.',
  'certificate.exam.2.course': 'Master Course',
  'certificate.exam.2.content': 'Graduation dinner practicum (formal banquet)',
  'certificate.exam.2.desc': 'Candidates manage the full sequence of a formal banquet, from planning and set-up through service. Staff coordination and the ability to respond to unexpected situations are also assessed.',

  // awardItems
  'certificate.award.title': 'What Successful Candidates Receive',
  'certificate.award.lead': 'The following are awarded to those who pass the final practical examination — each serving as official evidence of the skills acquired.',
  'certificate.award.item.0.name': 'Certificate of Certification',
  'certificate.award.item.0.desc': 'An official certificate issued by the All Japan Butler Association. It records the name of the certification, the certification number, and the date of award.',
  'certificate.award.item.1.name': 'Certified Lapel Pin',
  'certificate.award.item.1.desc': 'A lapel pin in a design corresponding to the certification level — a wearable mark of your credential in professional settings.',
  'certificate.award.item.2.name': 'Certification Number',
  'certificate.award.item.2.desc': 'A unique number assigned to each certified individual. It is registered in the Association\'s certified holder register, enabling authenticity verification.',
  'certificate.award.item.3.name': 'Digital Certificate (PDF)',
  'certificate.award.item.3.desc': 'A print-ready digital certificate in PDF format. May be used for CV attachments or sharing on social media (on request only).',
  'certificate.award.rosterNote': '* Registration in the certified holder register is subject to consent. Personal data is handled in accordance with our privacy policy.',

  // usageSection
  'certificate.usage.title': 'Making Use of Your Certification',
  'certificate.usage.lead': 'The certification provides an objective demonstration of your professional expertise as a butler. It can be used as evidence of your skill level when applying for employment. \n\nA graduate job information system is also in development to support career development.',
  'certificate.usage.point.0.title': 'Proof of Skills for Employment',
  'certificate.usage.point.0.desc': 'The certificate and lapel pin may be used as objective supporting documentation to demonstrate your level of butler expertise to third parties.',
  'certificate.usage.point.1.title': 'Access to Job Information (in preparation)',
  'certificate.usage.point.1.desc': 'We are developing a system to share butler-related job opportunities identified by the Association with graduates, to help expand their career options.',
  'certificate.usage.point.2.title': 'A Mark of Trust',
  'certificate.usage.point.2.desc': 'The Association certification serves as a trustworthy indicator that you possess skills above a defined threshold — valuable for both employers and clients.',
  'certificate.usage.note': '* The certification does not guarantee employment. It is a demonstration of skill level; job searching is the responsibility of the individual.',

  // certificateFaqs
  'certificate.faq.0.q': 'What certifications can I earn?',
  'certificate.faq.0.a': 'There are three levels: Certified Associate, Certified Professional, and Certified Master Butler. They are awarded to those who pass the final practical examination at the end of the respective course.',
  'certificate.faq.1.q': 'Is this a national qualification?',
  'certificate.faq.1.a': 'No. It is a private credential issued exclusively by the All Japan Butler Association.',
  'certificate.faq.2.q': 'What happens if I fail the examination?',
  'certificate.faq.2.a': 'You may resit on one occasion free of charge at the next scheduled session. Subsequent resit attempts are subject to a fee of JPY 11,000 (tax incl.).',

  // certificateRelatedPages
  'certificate.related.0.title': 'Enrollment Benefits',
  'certificate.related.0.desc': 'Practical enrollment gifts',
  'certificate.related.1.title': 'Courses Overview',
  'certificate.related.1.desc': 'Compare all three courses at a glance',
  'certificate.related.2.title': 'Skills Acquired',
  'certificate.related.2.desc': 'Five skill domains you will develop',
  'certificate.related.3.title': 'About the All Japan Butler Association',
  'certificate.related.3.desc': 'The organisation behind the academy and its programmes',
};

export default certificate;
